var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.4 7 16-4c.4-.1.7.2.6.6l-4 16c-.1.5-.8.5-1 0l-2.1-7c-.1-.3 0-.7.2-.9l4.4-5.9c.1-.2-.1-.4-.3-.3L8.3 9.9c-.3.2-.6.3-.9.2L.4 8c-.5-.1-.5-.9 0-1z"
  })));
};
export default SvgSend;